import { UseFormReturn } from 'react-hook-form';

import { FormField, FormItem, FormMessage } from '@@/ui/primitives';
import { Field } from '../../../../schemas/entity';
import { CreateItemPayload } from '../../../../schemas/item';
import { PickListInput } from '../../../shared/field-inputs';

interface PickListFieldRendererProps {
  fieldKey: string;
  field: Field;
  form: UseFormReturn<CreateItemPayload['attributes']>;
  label: string;
  disabled?: boolean;
}

export function PickListFieldRenderer({ fieldKey, field, form, label, disabled = false }: PickListFieldRendererProps) {
  const definition = field.definition;

  if (definition.type !== 'picklist') {
    return null;
  }

  const { options, multiple } = definition;

  return (
    <FormField
      control={form.control}
      name={fieldKey}
      render={({ field: formField }) => (
        <FormItem>
          <PickListInput
            options={options}
            required={field.definition.required}
            multiple={multiple}
            value={formField.value || ''}
            onChange={formField.onChange}
            label={label}
            placeholder={`Select ${fieldKey}...`}
            disabled={disabled}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
